import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter, lastValueFrom, take } from 'rxjs';
import { MenuConfiguration } from 'src/business/models/main-configuration.model';
import { Link } from 'src/core-lib/navigation/models/link.model';
import { DialogModule } from 'src/layout/dialog/dialog.module';
import { BlurOrBlurWithinDirective } from 'src/layout/focus/blur-or-blur-within.directive';
import { MediaModule } from 'src/layout/media/media.module';
import { ContentCacheUtils } from 'src/utils/storage.util';
import { Uuid } from 'src/utils/uuid.util';
import { RecursiveLinkComponent } from '../recursive-link/recursive-link.component';

@Component({
    selector: 'app-header-menu',
    standalone: true,
    imports: [RouterModule, RecursiveLinkComponent, MediaModule, DialogModule, BlurOrBlurWithinDirective, TranslateModule],
    templateUrl: './header-menu.component.html',
    styleUrl: './header-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMenuComponent {
    menu: Partial<MenuConfiguration>;
    productMenu: Link[];
    contentMenu: Link[];
    selected: Link;
    isMobile = matchMedia('screen and (width <= 1240px)').matches ? null : -1;
    isDesktop = matchMedia('screen and (width > 1240px)').matches ? null : -1;
    animation: string;
    @HostBinding('style.--all-translation') allTranslation: string;

    constructor(
        private _detector: ChangeDetectorRef,
        private translateSerive: TranslateService,
    ) {
        this.menu = ContentCacheUtils.menu<MenuConfiguration>();
        this.productMenu = this.mapLinks(this.menu.productMenu);
        this.contentMenu = this.mapLinks(this.menu.contentMenu);
        lastValueFrom(translateSerive
            .get('MENU.MENU_ALL')
            .pipe(filter(_ => _ != null), take(1))
        ).then(_ => {
            this.allTranslation = `"${_}"`;
            this._detector.markForCheck();
        })
    }

    mapLinks(menu: Link[], parent?: Link): Link[] {
        return menu.map(link => {
            var _link = structuredClone(link);
            _link.prev = parent;
            _link.id = 'link-' + Uuid.create();
            if (_link?.children?.length > 0)
                _link.children = this.mapLinks(_link.children, _link);
            return _link;
        })
    }

    open(link?: Link) {
        if (!this.isModal()) {
            this.selected = link;
            window['menu-dialog'].show()
            var buttons = window['menu-dialog'].querySelectorAll('[open] > button');
            buttons[buttons.length - 1].focus();
        } else {
            this.animation = 'hide';
            this._detector.markForCheck();
            setTimeout(() => {
                this.selected = link;
                this.animation = 'show';
                var buttons = window['menu-dialog'].querySelectorAll('[open] > button');
                buttons[buttons.length - 1].focus();
                this._detector.markForCheck();
                setTimeout(() => {
                    this.animation = null;
                    this._detector.markForCheck();
                }, 300);
            }, 300);
        }
    }
    isModal() {
        return matchMedia('screen and (width <= 1240px)').matches
    }

    openMobileMenu() {
        window['menu-dialog'].showModal()
    }


}
